<template>
  <div>
    <HomeworkList v-if="curPage=='HomeworkList'" @changePage="changePage" />
    <HomeworkDetail :query="HomeworkDetailQuery" @changePage="changePage" v-if="curPage=='HomeworkDetail'"/>
    <QuestionPaper v-if="curPage=='QuestionPaper'" @changePage="changePage" :query="QuestionPaperQuery"/>
  </div>
</template>

<script>
import HomeworkList from './homeworkList.vue'
import HomeworkDetail from './homeworkDetail.vue'
import QuestionPaper from './questionPaper.vue'
export default {
  data(){
    return{
      curPage:'HomeworkList',
      HomeworkDetailQuery:{},
      QuestionPaperQuery:{}
    }
  },

  components:{
    HomeworkList,
    HomeworkDetail,
    QuestionPaper
  },
  methods:{
    changePage(payload){
      console.log(payload)
      const {query, page} = payload
      this.curPage = page
      if(page == 'HomeworkDetail'){
        this.HomeworkDetailQuery = query
        this.$emit('changeUnread')
        return
      }
      if(page == 'QuestionPaper'){
        this.QuestionPaperQuery = query
        return
      }
      
    }
  }
}
</script>

<style lang="scss" scoped>


</style>
